import angular from 'angular';
import uiRouter from 'angular-ui-router';
import routing from './notebook.routes';
import addHtml from './modal/add.html';

export class NoteBooksController {
    $http;
    socket;
    awesomeThings = [];
    notebooks = [];
    newThing = '';

    /*@ngInject*/
    constructor($http, $scope, socket, $uibModal, $cookies, $cookieStore, $location, $timeout) {
        this.$http = $http;
        this.socket = socket;
        this.$uibModal = $uibModal;
        this.$cookies = $cookies;
        this.$cookieStore = $cookieStore;
        this.$location = $location;
        this.$timeout = $timeout;


        $scope.$on('$destroy', function () {
            socket.unsyncUpdates('notebook');
        });
    }

    $onInit() {
        if (this.$cookies.get('token')) {
            this.$http.get('/api/notebooks/9527/ng/', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': 0,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        angular.forEach(response.data.data, function (item) {
                            item.notebook = JSON.parse(item.notebook);
                        });
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.currentPage = 1;
                        this.notebooks = response.data.data;

                        this.socket.syncUpdates('notebooks', this.notebooks);
                    }
                });
        } else {
            this.$location.path('main')
        }
    }

    search() {

        if (this.$cookies.get('token')) {
            this.$http.get('/api/notebooks/9527/ng', {
                header: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'token': this.$cookies.get('token')
                },
                params: {
                    'page': this.currentPage - 1,
                    'size': 20
                }
            })
                .then(response => {
                    if (response.data.data) {
                        angular.forEach(response.data.data, function (item) {
                            item.notebook = JSON.parse(item.notebook);
                        });
                        this.maxSize = 20;
                        this.totalCount = response.data.count;
                        this.totalItems = response.data.count / 2;
                        this.notebooks = response.data.data;

                        this.socket.syncUpdates('notebooks', this.notebooks);
                    }
                });
        } else {
            this.$location.path('main')
        }


    }


    exprotExcel() {
        this.$http.get('/api/notebooks/1/1/', {}).then((response) => {
            if (response.status === 200) {
                console.log(response.data.data);
                this.$timeout(window.open('https://www.bibliagratis.mobi' + response.data.data, "_blank"), 5000)
            }
        }, (error) => {
            console.log(error);
        });
    }

    // addThing() {
    //   if(this.newThing) {
    //     this.$http.post('/api/things', {
    //       name: this.newThing
    //     });
    //     this.newThing = '';
    //   }
    // }

    deleteNoteBook(notebook, index) {
        this.$http.delete(`/api/notebooks/${notebook.note_book_id}`).then(response => {
            if (response.status === 204) {
                this.notebooks.splice(index, 1)
            }
        }, error => {
            console.log(error);
        });
    }


    // addSurvey() {
    //   const surveys = this.surveys;
    //   this.$uibModal.open({
    //     template: addHtml,
    //     size: 'lg',
    //     /*@ngInject*/
    //     controller: function($scope, $http, $uibModalInstance) {
    //       $scope.vm = {};
    //       $scope.save = function(myForm) {
    //         if (myForm.$valid === false) {
    //           return false;
    //         } else {
    //           $http.post('/api/surveys', $scope.vm).then((response) => {
    //             $uibModalInstance.close(response.data);
    //           }, (error) => {
    //             console.log(error);
    //           });
    //         }
    //       };
    //       $scope.cancel = function() {
    //         $uibModalInstance.close();
    //       };
    //     }
    //   })
    //     .result.then(function(ret) {
    //     if (ret) {
    //       surveys.push(ret);
    //     }
    //   }, function () {
    //   });
    // }

}

export default angular.module('tttApp.notebook', [uiRouter])
    .config(routing)
    .component('notebook', {
        template: require('./notebook.html'),
        controller: NoteBooksController
    })
    .name;



// WEBPACK FOOTER //
// ./client/app/notebook/notebook.component.js